export default __webpack_public_path__ + "9f5d9c9c28a48e15c233be164d5b11cd.png";